import React from "react";
import { Component, Fragment } from "react";
import {
	Progress,
	Card,
	CardBody,
  CardTitle,
	Input,
	Row,
	Col,
	Button,
	ListGroup,
	ListGroupItem,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
	Tooltip
} from 'reactstrap';

import img1 from '../../../assets/images/background/active-bg.png';
import Moment from 'moment';
import {
	appendProductFilter,
	beginDashboardRequest,
	finishDashboardRequest,
	markDashboardRequestSucceeded,
	getDashboardRefreshWait,
	getStoredProductType,
	PRODUCT_TYPE_ALL,
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA,
	ignoreDashboardRequestError,
	isDashboardRequestCurrent,
	scheduleDashboardRetry,
	stopDashboardPolling
} from '../product-filter';
import DashboardCardLoader from '../dashboard-card-loader';
import CenteredBlackDropdown from '../../mobile-vitals-dashboard/centered-black-dropdown/centered-black-dropdown';
var moment = require('moment-timezone');

const EVO_CATEGORY_OPTIONS = [
	{ label: "Non Surgical", value: "1-1", categoryID: 1, productID: PRODUCT_TYPE_EVO },
	{ label: "Surgical", value: "1-2", categoryID: 2, productID: PRODUCT_TYPE_EVO },
	{ label: "Pain Relief", value: "1-3", categoryID: 3, productID: PRODUCT_TYPE_EVO },
];

const NOVA_CATEGORY_OPTIONS = [
	{ label: "Non Surgical", value: "2-1", categoryID: 1, productID: PRODUCT_TYPE_NOVA },
	{ label: "Surgical", value: "2-2", categoryID: 2, productID: PRODUCT_TYPE_NOVA },
	{ label: "Hygiene", value: "2-4", categoryID: 4, productID: PRODUCT_TYPE_NOVA },
	{ label: "Orthodontics", value: "2-5", categoryID: 5, productID: PRODUCT_TYPE_NOVA },
];

const ALL_CATEGORY_OPTIONS = [
	{ label: "EVO - Non Surgical", value: "1-1", categoryID: 1, productID: PRODUCT_TYPE_EVO },
	{ label: "EVO - Surgical", value: "1-2", categoryID: 2, productID: PRODUCT_TYPE_EVO },
	{ label: "EVO - Pain Relief", value: "1-3", categoryID: 3, productID: PRODUCT_TYPE_EVO },
	{ label: "Nova - Non Surgical", value: "2-1", categoryID: 1, productID: PRODUCT_TYPE_NOVA },
	{ label: "Nova - Surgical", value: "2-2", categoryID: 2, productID: PRODUCT_TYPE_NOVA },
	{ label: "Nova - Hygiene", value: "2-4", categoryID: 4, productID: PRODUCT_TYPE_NOVA },
	{ label: "Nova - Orthodontics", value: "2-5", categoryID: 5, productID: PRODUCT_TYPE_NOVA },
];

let lineOptions56 = {
	tooltips: {
		titleFontSize: 16,
		bodyFontSize: 14
	},
};

class TopProceduresCat extends React.Component {

	noResults = true;
	intervalID = 0;

	constructor(props) {
    super(props);
		const productType = getStoredProductType();
    this.state = {
			rSelected: parseInt(productType) === PRODUCT_TYPE_NOVA ? "2-2" : "1-2",
			topProcedures: [],
			colors: [{color:'warning'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}, {color:'cyan'}, {color:'warning'}, {color:'success'}, {color:'info'}, {color:'teal'}],
			noDevices: false,
			noDataForDevices: false,
			currentDataSetting: 0,
			startDate: Moment().subtract(3, 'year').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Global",
			tooltipOpen: false,
			totalProceduresLabel: 0,
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			ratioRange: 100,
			marketType: localStorage.getItem('marketType') ? JSON.parse(localStorage.getItem('marketType')) : 0,
			productType,
			isLoading: false
	  };

		this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.toggleTooltip = this.toggleTooltip.bind(this);
  }

	async componentDidMount() {

		document.body.addEventListener('set-market-type', this.handleMarketTypeChange.bind(this));
		document.body.addEventListener('set-product-type', this.handleProductTypeChange.bind(this));

		if (this.state.currentUser) {
			this.scheduleDataRefresh(this.state.rSelected);
		} else {
			this.scheduleDataRefresh(this.state.rSelected);
		}
	}

	scheduleDataRefresh(category, delay, showLoader = true) {
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (showLoader) {
			this.setState({
				isLoading: true,
				totalProceduresLabel: 0
			});
		}
		this.dashboardRefreshTimeout = setTimeout(()=>{ this.getData(category, { showLoader }); }, delay || getDashboardRefreshWait('topProceduresCat'));
	}

	handleMarketTypeChange(event) {
    console.log("Top Procedures Category Market has changed to: ", event.detail);

		this.setState({ marketType: event.detail.id });
		this.scheduleDataRefresh(this.state.rSelected);
  }

	handleProductTypeChange(event) {
    console.log("Top Procedures Category Product has changed to: ", event.detail);
		const productType = event.detail.id;
		const categoryOptions = this.getCategoryOptions(productType);
		const selectedCategory = categoryOptions.find(option => option.value === this.state.rSelected);
		const rSelected = selectedCategory ? this.state.rSelected : this.getDefaultCategoryValue(productType);
		this.setState({ productType, rSelected });
		this.scheduleDataRefresh(rSelected);
  }

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	handleChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({startDate: event.target.value});
			this.setState({
	      currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({endDate: event.target.value});
			this.setState({
				currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		}

		this.scheduleDataRefresh(this.state.rSelected);
  }

	handleSubmit(event) {

		this.getData(this.state.rSelected, { showLoader: true });
  }

	selectDropDownItem(id, title) {

    this.setState({
      currentItem: title,
			currentDataSetting: id
    });

		if (id==1) {
			this.setState({ startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD') });
		} else if (id==2) {
			this.setState({ startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD') });
		} else if (id==3) {
			this.setState({ startDate: Moment().format('YYYY-MM-DD') });
		}

		this.setState({ endDate: Moment().format('YYYY-MM-DD') });

		this.scheduleDataRefresh(this.state.rSelected);
  }

	stepBack () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}

		this.scheduleDataRefresh(this.state.rSelected);
	}

	stepForward () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}

		this.scheduleDataRefresh(this.state.rSelected);
	}

	componentWillUnmount() {
		//console.log("Dashboard componentWillUnmount");
		clearInterval(this.intervalID);
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (this.dashboardAbortController) {
			this.dashboardAbortController.abort();
		}
		document.body.removeEventListener('set-market-type', this.handleMarketTypeChange.bind(this));
		document.body.removeEventListener('set-product-type', this.handleProductTypeChange.bind(this));
	}

	async onRadioBtnClick(rSelected) {
		await this.setState({ rSelected });
		await this.getData(rSelected, { showLoader: true });
	}

	getCategoryOptions(productType = this.state.productType) {
		switch (parseInt(productType)) {
			case PRODUCT_TYPE_EVO:
				return EVO_CATEGORY_OPTIONS;
			case PRODUCT_TYPE_NOVA:
				return NOVA_CATEGORY_OPTIONS;
			default:
				return ALL_CATEGORY_OPTIONS;
		}
	}

	getDefaultCategoryValue(productType = this.state.productType) {
		return parseInt(productType) === PRODUCT_TYPE_NOVA ? "2-2" : "1-2";
	}

	getSelectedCategoryOption(categoryValue = this.state.rSelected) {
		const categoryOptions = this.getCategoryOptions();
		return categoryOptions.find(option => option.value === categoryValue) || categoryOptions[0];
	}

	getData = async (category, options = {}) => {
		const request = beginDashboardRequest(this, options.showLoader === true);
		if (options.showLoader === true) {
			this.setState({ totalProceduresLabel: 0 });
		}
		const signal = request.controller.signal;
		const selectedCategory = this.getSelectedCategoryOption(category);
		const categoryID = selectedCategory.categoryID;
		const productType = parseInt(this.state.productType) === PRODUCT_TYPE_ALL ? selectedCategory.productID : this.state.productType;

		var timezone = Moment.tz.guess();

		if (this.state.currentDataSetting==0) {
			var url = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"top-procedures-by-category?MarketType="+this.state.marketType+"&CategoryId="+categoryID, productType);

			var token = "";

			if (this.state.currentUser) {
				token = this.state.currentUser.jwtToken;
			}

			if (this.props.authToken) {
				console.log("top-procedures-cat this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {

				const response = await fetch(url, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("topprocedures by cat body response: " + JSON.stringify(body));

				if (body.status == 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);

					var total = 0;

					body.results.map((prop, key) => {
						total = total + parseInt(prop.total);
					});

					this.setState({ totalProceduresLabel: total });

					if (body.results.length>0) {
						var largest = 100;
						for (var i=0; i < body.results.length; i++) {
							if (body.results[i].total > largest) {
								largest = body.results[i].total;
							}
						}
						this.setState({ topProcedures: body.results }, () => console.log(this.state.topProcedures));
						this.setState({
							noDataForDevices: false,
							ratioRange: 2*largest
				    });
					} else {

						if (this.state.currentUser && this.state.currentUser.role && this.state.currentUser.role>1) {
							if (this.state.topProcedures.length>0) {
								this.setState({
									noDataForDevices: false
								});
							} else {
								this.setState({
									noDataForDevices: true
								});
							}
						} else {
							this.setState({
								noDataForDevices: true
							});
						}

					}
				} else {
					if (this.state.currentUser && this.state.currentUser.role && this.state.currentUser.role>1) {
						if (this.state.topProcedures.length>0) {
							this.setState({
								noDataForDevices: false
							});
						} else {
							this.setState({
								noDataForDevices: true
							});
						}
					} else {
						this.setState({
							noDataForDevices: true
						});
					}
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData(category, { showLoader: true }))) {
					console.log(err);
				}
			}

		} else {
			var url = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"top-procedures-by-category-date-range?MarketType="+this.state.marketType+"&CategoryId="+categoryID+"&StartDate="+this.state.startDate+"&EndDate="+this.state.endDate+"&Timezone="+timezone, productType);

			var token = "";

			if (this.state.currentUser) {
				token = this.state.currentUser.jwtToken;
			}

			if (this.props.authToken) {
				console.log("top-procedures-cat this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {

				const response = await fetch(url, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("topprocedures by cat body response: " + JSON.stringify(body));

				if (body.status == 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);

					var total = 0;

					body.results.map((prop, key) => {
						total = total + parseInt(prop.total);
					});

					this.setState({ totalProceduresLabel: total });

					if (body.results.length>0) {
						var largest = 100;
						for (var i=0; i < body.results.length; i++) {
							if (body.results[i].total > largest) {
								largest = body.results[i].total;
							}
						}
						this.setState({ topProcedures: body.results }, () => console.log(this.state.topProcedures));
						this.setState({
							noDataForDevices: false,
							ratioRange: 2*largest
				    });
					} else {
						if (this.state.currentUser && this.state.currentUser.role && this.state.currentUser.role>1) {
							if (this.state.topProcedures.length>0) {
								this.setState({
									noDataForDevices: false
								});
							} else {
								this.setState({
									noDataForDevices: true
								});
							}
						} else {
							this.setState({
								noDataForDevices: true
							});
						}
					}
				} else {
					if (this.state.currentUser && this.state.currentUser.role && this.state.currentUser.role>1) {
						if (this.state.topProcedures.length>0) {
							this.setState({
								noDataForDevices: false
							});
						} else {
							this.setState({
								noDataForDevices: true
							});
						}
					} else {
						this.setState({
							noDataForDevices: true
						});
					}
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData(category, { showLoader: true }))) {
					console.log(err);
				}
			}

		}

		finishDashboardRequest(this, request.requestId, () => this.getData(category, { showLoader: false }));
	}

	getColor(presetID) {

		var color = "success";

		if (presetID>=1 && presetID<=5) {
			color = "success";
		} else if (presetID>=11 && presetID<=19) {
			color = "info";
		} else if (presetID>=21 && presetID<=23) {
			color = "yellow";
		}

		return color;

	}

	render() {
		const categoryOptions = this.getCategoryOptions();

		return (
			/*--------------------------------------------------------------------------------*/
			/* Used In Dashboard-1 [Classic]                                                  */
			/*--------------------------------------------------------------------------------*/
			<Card className="card-hover">
				<CardBody style={{ minHeight: 650 }}>
					<Row>
						<Col xs="5" md="5" lg="5" className="text-left">
							<CardTitle>Top Procedures by Category
							<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="TopProceduresCatTooltip"/>
							<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TopProceduresCatTooltip" toggle={this.toggleTooltip}>
								Displays the most common procedures performed by category by desired time period, as well as how many times each of these top procedures were performed.
							</Tooltip>
							</CardTitle>
						</Col>
						<Col xs="3" md="3" lg="3" className="text-right">
							<h5 className="text-center" style={{color: '#fec007', lineHeight: "1.7"}}>{this.state.totalProceduresLabel}</h5>
						</Col>
						<Col xs="4" md="4" lg="4" className="text-right">
							<ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
								<DropdownToggle color="dark" caret>
									{this.state.currentItem}
								</DropdownToggle>
								<DropdownMenu right>
									<DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(1, 'By Week')}>By Week</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(2, 'By Month')}>By Month</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(3, 'Custom Range')}>Custom Range</DropdownItem>
								</DropdownMenu>
							</ButtonDropdown>
						</Col>
					</Row>
					{this.state.noDevices ? (
						<div className="mt-5 text-center">
							<h5>User has no devices</h5>
						</div>
					) : (
						<Fragment>
						{this.state.currentDataSetting == 0 || this.state.currentDataSetting == 3 ? (
							<Fragment>
							<Row className="pt-3">
								<Col xs="12" md="12" lg="12">
									<div className="mt-1 mb-1">
										<CenteredBlackDropdown
											options={categoryOptions}
											value={this.state.rSelected}
											onChange={(value) => this.onRadioBtnClick(value)}
											placeholder="Select Category"
										/>
									</div>
								</Col>
							</Row>
							<div className="ml-auto mt-1" style={{height: '390px'}}>
									{this.state.isLoading ? (
										<DashboardCardLoader />
									) : this.state.noDataForDevices ? (
										<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
											<h5>No data for user's devices</h5>
										</div>
									) : (
										<div className="pt-3">
											{this.state.topProcedures.map((procedure, i) => (
												<Fragment>
												<Row key={i}>
													<Col xs="3" md="3" lg="3" className="text-left">
														<span>{procedure.total}</span>
													</Col>
													<Col xs="9" md="9" lg="9" className="text-right">
														{procedure.name == "7mm" || procedure.name == "3mm" || procedure.name == "25mm" ? (
															<span>{procedure.name} PBM</span>
														) : (
															<span>{procedure.name}</span>
														)}
													</Col>
												</Row>
												<Progress multi className="mt-2 mb-3">
													<Progress bar color={this.getColor(procedure.preset)} value={(procedure.total/this.state.ratioRange)*100} />
												</Progress>
												</Fragment>
											))}
										</div>
									)}
							</div>
							{this.state.currentDataSetting != 0 &&
								<Fragment>
								<Row className="pt-5 mt-5">
									<Col lg="12" xl="6" className="text-right">
										<div className="float-left" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
										</div>
									</Col>
									<Col lg="12" xl="6" className="">
										<div className="float-left text-right" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
										</div>
										{
											// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
											// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go" disabled={this.state.currentDataSetting != 3}>
											// 	GO
											// </Button>
											// </div>
										}
									</Col>
								</Row>
								</Fragment>
							}
							</Fragment>
						) : (
							<Fragment>
							<Row className="pt-3">
								<Col xs="12" md="12" lg="12">
									<div className="mt-1 mb-1">
										<CenteredBlackDropdown
											options={categoryOptions}
											value={this.state.rSelected}
											onChange={(value) => this.onRadioBtnClick(value)}
											placeholder="Select Category"
										/>
									</div>
								</Col>
							</Row>
							<Row className="align-items-center mt-4" style={{height: '370px'}}>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" onClick={() => this.stepBack()} title="Step Back">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
									</Button>
								</div>
								<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
									<div className="ml-4 mt-1">
											{this.state.isLoading ? (
												<DashboardCardLoader />
											) : this.state.noDataForDevices ? (
												<div className="d-flex justify-content-center align-items-center" style={{ height: '100%'}}>
													<h5>No data for user's devices</h5>
												</div>
											) : (
												<div className="pt-1">
													{this.state.topProcedures.map((procedure, i) => (
														<Fragment>
														<Row key={i}>
															<Col xs="3" md="3" lg="3" className="text-left">
																<span>{procedure.total}</span>
															</Col>
															<Col xs="9" md="9" lg="9" className="text-right">
																{procedure.name == "7mm" || procedure.name == "3mm" || procedure.name == "25mm" ? (
																	<span>{procedure.name} PBM</span>
																) : (
																	<span>{procedure.name}</span>
																)}
															</Col>
														</Row>
														<Progress multi className="mt-2 mb-3">
															<Progress bar color={this.getColor(procedure.preset)} value={(procedure.total/this.state.ratioRange)*100} />
														</Progress>
														</Fragment>
													))}
												</div>
											)}
									</div>
								</div>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Step Forward">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
									</Button>
								</div>
							</Row>
							<Row className="pt-5 mt-5">
								<Col lg="12" xl="6" className="text-right">
									<div className="float-left" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
									</div>
								</Col>
								<Col lg="12" xl="6" className="">
									<div className="float-left text-right" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
									</div>
									{
										// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
										// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Go">
										// 	GO
										// </Button>
										// </div>
									}
								</Col>
							</Row>
							</Fragment>
						)}
						</Fragment>
					)}
				</CardBody>
			</Card>

		);
	}
}

export default TopProceduresCat;
